import clsx from 'clsx';
import React__default, { Component } from 'react';
import { Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import '../../../theme/Typography.es.js';
import { I as Icons } from '../../../index-Bx7dqCI-.mjs';

const root = "_root_1w0hf_1";
const styles = {
	root: root
};

const MissingIcon = () => React__default.createElement(
  "svg",
  { "aria-label": "Could not load icon", "data-is-missing-icon": "true", viewBox: "0 0 24 24" },
  React__default.createElement("rect", { height: "24", width: "24", x: "0", y: "0" })
);
class IconErrorBoundary extends Component {
  constructor() {
    super(...arguments);
    this.state = {
      didFailToLoad: false
    };
  }
  static getDerivedStateFromError() {
    return {
      didFailToLoad: true
    };
  }
  render() {
    return this.state.didFailToLoad ? React__default.createElement(MissingIcon, null) : this.props.children;
  }
}
function getCssSize(size) {
  if (size === "small" || size === void 0) {
    return "24px";
  }
  if (size === "medium") {
    return "36px";
  }
  if (size === "large") {
    return "48px";
  }
  return size;
}
const Icon = ({ "aria-label": ariaLabel, color, isBlock = false, name, "aria-hidden": ariaHidden = true, canAcceptPointerEvents = true, shouldAnimateFill = true, size = "small", className }) => {
  const IconComponent = getIcon(name);
  const cssSize = getCssSize(size);
  return React__default.createElement(
    "span",
    { "aria-hidden": ariaHidden ? "true" : void 0, "aria-label": ariaLabel, className: clsx(styles.root, `zds-deprecated-icon-${name}`, className), "data-testid": "iconContainer", "data-zds": true, "data-block": isBlock, "data-pointer-events": canAcceptPointerEvents, "data-animate": shouldAnimateFill, style: {
      "--_zds-icon-height": cssSize,
      "--_zds-icon-width": cssSize,
      "--_zds-icon-fill": color ? Colors[color] : "currentColor"
    } },
    React__default.createElement(
      IconErrorBoundary,
      null,
      React__default.createElement(IconComponent, { size: cssSize, color, name })
    )
  );
};
const nameMap = (/* @__PURE__ */ new Map()).set("actionAIText", "ActionAiText").set("actionAIFix", "ActionAiFix").set("miscAI", "MiscAi").set("miscAI", "MiscAi").set("miscAIFill", "MiscAiFill").set("navAIChatbot", "NavAiChatbot").set("miscEvergreenAI", "MiscEvergreenAi").set("miscMCP", "MiscMcp").set("navMCP", "NavMcp");
function capitalize(string) {
  return string[0].toUpperCase() + string.slice(1);
}
function getIcon(name) {
  try {
    const realName = nameMap.get(name);
    if (realName) {
      return Icons[realName] || MissingIcon;
    }
    const capitalizedIcon = capitalize(name);
    return Icons[capitalizedIcon] || MissingIcon;
  } catch (_a) {
    return MissingIcon;
  }
}

export { Icon };
//# sourceMappingURL=Icon.es.js.map
